export default __webpack_public_path__ + "static/vfsGlobal-0a94b7f7187620cad49df5acb01afe57.jpg";